import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ListItem} from '@material-ui/core/';
import DeleteIcon from '@material-ui/icons/DeleteForeverRounded';
import { Tooltip, ListItemIcon } from '@material-ui/core';

const styles = theme => ({
    listItem: {    
        fontSize: '12px',
        padding: '0px',
        display: 'flex',
        borderBottom: '1px solid #e0e0e0'
    },
    trashIcon: {
        marginLeft: '16px',
        marginRight: '10px',
        display: 'inline-flex',
        flexShrink: '0',
        cursor: 'pointer',
    },
    listItemText: {
        padding: '0px'
    }
});

const genLiPath = (selectedLocationTree, classes, props) => {
    return selectedLocationTree.length === 0 ? '' : selectedLocationTree.map((location, index) => {
        return (
            <div key={location.nodeId} className={classes.listItem}>
                <Tooltip title={location.description}>
                    <ListItem className={classes.listItemText}>
                        {location.path}
                    </ListItem>
                </Tooltip>
                <Tooltip title={'Remove ' + location.description}>
                    <ListItemIcon className={classes.trashIcon}>
                        <DeleteIcon
                            variant="contained" color="primary"
                            onClick={() => props.modifySelection(location.path, index)}
                            className='Tree__Buttons__Remove' />
                    </ListItemIcon>
                </Tooltip>
            </div>
        );
    });
}

const TreeNode = (props) => {
    const { currentSelection, classes } = props;
    return (
        genLiPath(currentSelection, classes, props)
    );
}

export default withStyles(styles)(TreeNode);